import script from "./DateEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./DateEditor.vue?vue&type=script&lang=ts&setup=true"

import "./DateEditor.vue?vue&type=style&index=0&id=d65b917e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d65b917e"]])

export default __exports__